/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useConnect } from "wagmi";
import { Image, Spinner } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import { useSignMessage, useAccount } from "wagmi";
import { polygonMumbai, sepolia, polygon, mainnet } from "wagmi/chains";

import ErrorModal from "components/modals/ErrorModal";

import {
  createEthereumSiweMessage,
  verifyEthereumMessage,
} from "../../hooks/useSIWE";

import { useContextValues } from "context/app-context";
import { getParseEnvChainIds } from "utils/helper";

export function EthWallets({ handleClose }) {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showNetworkError, setShowNetworkError] = useState(false);
  const getChainSelected = localStorage?.getItem("networkSelected");
  const { address, connector } = useAccount();
  const {
    showErrorModal,
    handleSignFromWallet,
    networkSelected,
    handleOpenCloseErrorModal,
    handleDisConnectWallet,
  } = useContextValues();

  let chainId = process.env.REACT_APP_ENV === 'PROD'? mainnet?.id: polygonMumbai?.id;
  if (networkSelected === 80001) {
    chainId = polygonMumbai?.id;
  } else if (networkSelected === 11155111) {
    chainId = sepolia?.id;
  } else if (networkSelected === 137) {
    chainId = polygon?.id;
  } else if (networkSelected === 1) {
    chainId = mainnet?.id;
  }

  const { connect, connectors, error, isLoading, pendingConnector } =
    useConnect({
      chainId: chainId,
    });

  const {
    signMessageAsync,
    isLoading: signing,
    error: signError,
  } = useSignMessage();

  const isMobile = useMediaQuery({ query: "(max-width: 1180px)" });

  const supportedChains = getParseEnvChainIds();

  const signMessage = async () => {
    if (isLoading === true || signing === true) {
      setLoading(true);
    } else if (error || signError) {
      handleOpenCloseErrorModal(true);
      handleSignFromWallet(false);
      handleDisConnectWallet();
      if (error?.message.includes("chains")) {
        setShowNetworkError(true);
      } else {
        setShowNetworkError(false);
        setErrorMessage(
          error?.message
            ? "User Denied Authorization"
            : signError?.message
            ? "You did not provide a signature for this transaction."
            : "Unknown Error"
        );
      }
      setLoading(false);
    }

    if (address || (!error && !signError)) {
      handleOpenCloseErrorModal(false);
      connector?.getChainId().then(async (chainID) => {
        if (!supportedChains.includes(chainID)) {
          handleOpenCloseErrorModal(true);
          setShowNetworkError(true);
          handleDisConnectWallet();
          setLoading(false);
        } else {
          setShowNetworkError(false);
          handleOpenCloseErrorModal(false);

          const message = createEthereumSiweMessage(
            address,
            "Sign in with Ethereum to Virtua Chain.",
            chainID
          );

          // Convert your message to a byte array
          let byteArray = new Uint8Array(message.length);
          for (let i = 0; i < message.length; i++) {
            byteArray[i] = message.charCodeAt(i);
          }

          // Encode the byte array using Base64
          let base64Encoded = btoa(String.fromCharCode.apply(null, byteArray));
          let verified = false;

          try {
            const signature = await signMessageAsync({ message });
            localStorage.setItem("wagmi.walletSignature", signature);
            localStorage.setItem("wagmi.walletMessage", base64Encoded);

            verified = await verifyEthereumMessage(message, signature);
            if (verified) {
              handleClose();
              setLoading(false);
              localStorage.setItem("isSigned", true);
              handleSignFromWallet(true);
            } else {
              localStorage.removeItem("isSigned");
              handleSignFromWallet(false);
            }
          } catch (error) {
            localStorage.removeItem("isSigned");
            localStorage.removeItem("wagmi.walletAddress");
            handleSignFromWallet(false);
            handleOpenCloseErrorModal(true);
          }
        }
      });
    }
  };
  const handleButtonClick = async (connector) => {
    if (!connector.ready) {
      window.open("https://metamask.io/download/", "_blank");
    } else {
      if (connector?.name === "WalletConnect" && isMobile) {
        handleClose();
      }
      setLoading(true);
      connect({ connector });
    }
  };

  useEffect(() => {
    signMessage();
  }, [address, error, signError]);

  return (
    <>
      <ul className="d-flex">
        {connectors.map((connector, index) => (
          <li key={`eth${index + 1}`}>
            <button
              key={connector?.id}
              onClick={() => handleButtonClick(connector)}
              className="custom-btn lg dim-border w-100 rounded"
            >
              {connector?.name === "MetaMask" ? (
                <Image
                  src={process.env.REACT_APP_S3_IMAGE_PATH + "metamaskBtn.png"}
                  alt="metamask"
                />
              ) : connector?.name === "WalletConnect" ? (
                <Image
                  src={process.env.REACT_APP_S3_IMAGE_PATH + "connectBtn.png"}
                  alt="walletconnect"
                />
              ) : (
                <Image
                  src={process.env.REACT_APP_S3_IMAGE_PATH + "coinbaseBtn.png"}
                  alt="coinbasewallet"
                />
              )}
              <span className="txt">
                {loading && connector.id === pendingConnector.id ? (
                  <div className="spinner">
                    <Spinner
                      animation="border"
                      role="status"
                      style={{ width: "1.5rem", height: "1.5rem" }}
                      variant="secondary"
                    />
                  </div>
                ) : (
                  `Continue With ${connector.name}`
                )}
              </span>
            </button>
          </li>
        ))}
        {(errorMessage.includes("Authorization") ||
          errorMessage.includes("signature")) && (
          <ErrorModal
            show={showErrorModal}
            onHide={handleOpenCloseErrorModal}
            errorMessage={errorMessage}
            handleClose={handleClose}
            errorTitle={"Transaction Cancelled"}
          />
        )}
        {showNetworkError && (
          <ErrorModal
            show={showErrorModal}
            onHide={handleOpenCloseErrorModal}
            errorMessage={
              "It looks like you are using the wrong network, Please switch to Ethereum Mainnet"
            }
            handleClose={handleClose}
            errorTitle={"Improper Network"}
          />
        )}
      </ul>
    </>
  );
}
